export const VTMN_TABS_ALIGN = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
};

export const VTMN_TABS_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
};
